import React from 'react';
import { Component } from 'react';
import Jumbo from './layout/jumbotron';

/*
import MidPage1 from './layout/mid-page1';
import MidPage2 from './layout/mid-page2';
import MidPage3 from './layout/mid-page3';
import MidPage4 from './layout/mid-page4';
*/

import ContactUs from './layout/contact-us';
import MainNavBar from './layout/main-navbar';


export default class Home extends Component {
    render(){
        return (
            <div>
                <MainNavBar/>
                <Jumbo/>
                <ContactUs/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/home.js